import { Button, Title } from '@qonsoll/react-design'
import { NewsTipFilter, NewspaperFilter, UserFilter } from './components'
import {
  StyledFilter,
  StyledHeader,
  buttonProps,
  filterBackground,
  filterMaxHeight,
  iconStyles
} from './PointsHistoryFilter.styles'

import { CloseOutlined } from '@ant-design/icons'
import PropTypes from 'prop-types'
import { useTranslations } from 'contexts/Translation'

const PointsHistoryFilter = (props) => {
  const { filterVisibility, setFilterVisibility, filterData, setFilterData } =
    props

  /* Getting translations instance */
  const { t } = useTranslations()

  /* Closing filter */
  const handleClose = () => setFilterVisibility(false)

  return filterVisibility ? (
    <>
      <StyledHeader background={filterBackground}>
        <Title mb={2} level={4}>
          {t('Filter')}
        </Title>
        <Button
          {...buttonProps}
          onClick={handleClose}
          icon={<CloseOutlined style={iconStyles} />}
        />
      </StyledHeader>
      <StyledFilter maxHeight={filterMaxHeight} background={filterBackground}>
        <NewspaperFilter
          filterData={filterData}
          setFilterData={setFilterData}
        />
        <UserFilter filterData={filterData} setFilterData={setFilterData} />
        <NewsTipFilter filterData={filterData} setFilterData={setFilterData} />
      </StyledFilter>
    </>
  ) : null
}

PointsHistoryFilter.propTypes = {
  filterVisibility: PropTypes.bool,
  setFilterVisibility: PropTypes.func,
  filterData: PropTypes.object,
  setFilterData: PropTypes.func
}

export default PointsHistoryFilter
